import PoiLabels from "./PoiLabels";

/**
 * Clase que extiende la funcionalidad de PoiLabels para gestionar etiquetas vacías.
 */
class EmptyLabels extends PoiLabels{
    /**
     * Crea una instancia de EmptyLabels.
     * @constructor
     */
    constructor() {
        super();
    }

    /**
     * Inicializa las propiedades de la instancia.
     * @override
     */
    initProperties() {
        super.initProperties();
        this.ident = "empty";
    }

    /**
     * Método para descargar datos de puntos de interés. (Sobrescrito como no implementado)
     * @override
     */
    /**
     * Método para descargar datos de puntos de interés. (Sobrescrito como no implementado)
     * @override
     */
    download() {}

    /**
     * Método para renderizar los puntos de interés. (Sobrescrito como no implementado)
     * @override
     */
    render() {}

    /**
     * Método para cancelar operaciones. (Sobrescrito como no implementado)
     * @override
     */
    cancel() {}

    /**
     * Método para eliminar datos. (Sobrescrito como no implementado)
     * @override
     */
    delete() {}

    /**
     * Método para activar la funcionalidad de las etiquetas vacías. (Sobrescrito como no implementado)
     * @override
     */
    activate() {}

    /**
     * Método para desactivar la funcionalidad de las etiquetas vacías. (Sobrescrito como no implementado)
     * @override
     */
    deactivate() {}
}

export default EmptyLabels;
